import { render, staticRenderFns } from "./TimelineScale.vue?vue&type=template&id=54c3c368&scoped=true&"
import script from "./TimelineScale.vue?vue&type=script&lang=js&"
export * from "./TimelineScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3c368",
  null
  
)

export default component.exports